<template>
    <div>
        <button @click="changeTable(false)" class="work-trip-btn">Назад</button>
        
        <my-loader v-if="isLoading"></my-loader>
        <div v-else class="table-page">
            <div class='content'>
                <table class="company-table">
                  <thead>
                      <tr>
                        <th>Номер</th>
                        <th>Дата начала</th>
                        <th>Дата завершения</th>
                        <th>Отправление</th>
                        <th>Назначение</th>                        
                        <th>Тип ТС</th>
                        <th>Название</th>
                        <th>Топ8</th>
                        <th></th>
                        <th></th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="trip in trips" :key="trip.id" class="row-card">
                        <td>{{ trip.trip_id }}</td>
                        <td>{{ trip.tms_date_start }}</td>
                        <td>{{ trip.tms_date_end }}</td>
                        <td>{{ trip.tms_city_out }}</td>
                        <td>{{ trip.tms_city_in }}</td>
                        <td>{{ trip.tms_cargo ? trip.tms_cargo.split(' ')[0] : trip.tms_cargo }}</td>
                        <td>
                            <font-awesome-icon 
                                v-if="trip.is_top" 
                                class="top-icon" icon="fa-solid fa-trophy" />
                            <span>{{ trip.tms_name_endpoint }}</span>
                        </td>
                        <td>{{ trip.is_top ? 'ТОП-8' : '-' }}</td>
                        <td><button class="confirm-btn confirm-bg" @click="confirmOrCancel(true)">Принять</button></td>
                        <td><button class="confirm-btn cancel-bg" @click="confirmOrCancel(false)">Отказ</button></td>
                      </tr>
                  </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
import { isCancel } from 'axios';

export default {
  name: 'CargosTable',
  props:['trips','isLoading'],
  setup(props,{emit}){

    const changeTable = (isWait) => {
      emit('changeTable',isWait)
    }

    const confirmOrCancel = (isCancel) =>{
      emit('confirmOrCancelTrip',isCancel)
    }

    return{
      confirmOrCancel,
      changeTable,
    }
  },

};

</script>

<style scoped>
.content {
  margin-top: 10px;
}

.company-table {
  margin-left: 20px;
  margin-right: 20px;
  border-collapse: collapse;
}

.company-table th,
.company-table td {
  text-align: center;
  padding: 3px;
  border: 1px solid #ccc;
}

.company-table th {
  font-weight: bold;
}

.row-card:hover{
  background-color: rgba(224, 187, 72, 0.4);
  cursor: pointer;
}

.top-icon{
  margin-right: 5px;
  width: 15px;
  height: 15px;
  color: #ae4ddb;
}

.work-trip-btn {
  margin-left: 20px;
  border-radius: 5px;
  padding: 5px;
  background-color: rgba(195,228,255,0.3);
}

.confirm-btn{
  border-radius: 2px;
  padding: 1px 3px;
  border: 1px solid;
}

.confirm-bg{
  
  background-color: rgba(195,228,255,0.3);
}

.cancel-bg{
  background-color: rgba(195,52,70,0.7);
}
</style>